import { createReducer } from "reduxsauce";
import Types from "./types";
import { SCREEN_STATES } from "../../../constants/car-history-constants";

export const INITIAL_STATE = {
    error: null,
    cmsContent: {
        isLoading: true,
        isError: false,
        isSSR: false
    },
    chrServiceOrder: {
        isLoading: false,
        isError: false
    },
    regoDetails: {
        isLoading: false,
        isError: false,
        data: {},
        chrRegoFormDetails: {
            userEmail: "",
            regNo: "",
            vin: "",
            state: "",
            year: ""
        }
    },
    chrLandingData: {
        isLoading: false,
        isError: false,
        data: {}
    },
    chrServiceOrderPayment: {
        isLoading: false,
        isError: false,
        data: {},
        selectedPaymentMode: "",
        agreeToTerms: false
    },
    chrServiceOrderList: {
        isLoading: false,
        isError: false,
        data: []
    },
    showCarHistoryFlowInitModal: false,
    currentFormState: "",
    paymentProcessStarted: false,
    isSSR: false
};

const fetchCmsDataInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        cmsContent: {
            ...state.cmsContent,
            isLoading: true
        }
    };
};
const fetchCmsDataSuccess = (state = INITIAL_STATE, { data = {} }) => {
    return {
        ...state,
        cmsContent: {
            ...state.cmsContent,
            isLoading: false,
            ...data
        }
    };
};
const fetchCmsDataFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        cmsContent: {
            ...state.cmsContent,
            isLoading: false,
            isError: true,
            error
        }
    };
};
const setCreateServiceOrderInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        chrServiceOrder: {
            ...state.chrServiceOrder,
            isLoading: true
        }
    };
};
const setCreateServiceOrderSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        chrServiceOrder: {
            ...state.chrServiceOrder,
            isLoading: false,
            ...data
        }
    };
};
const setCreateServiceOrderFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        chrServiceOrder: {
            ...state.chrServiceOrder,
            isLoading: false,
            isError: true,
            error
        }
    };
};
const fetchRegoDetailsInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        regoDetails: {
            ...state.regoDetails,
            isLoading: true
        },
        currentFormState: SCREEN_STATES.SEARCHING_REGO_DETAILS
    };
};
const fetchRegoDetailsSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        regoDetails: {
            ...state.regoDetails,
            isLoading: false,
            data
        }
    };
};
const fetchRegoDetailsFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        regoDetails: {
            ...state.regoDetails,
            isLoading: false,
            isError: true,
            error
        },
        currentFormState: SCREEN_STATES.VEHICLE_NOT_FOUND
    };
};
const fetchChrLandingDataInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        chrLandingData: {
            ...state.chrLandingData,
            isLoading: true
        }
    };
};
const fetchChrLandingDataSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        chrLandingData: {
            ...state.chrLandingData,
            isLoading: false,
            data
        }
    };
};
const fetchChrLandingDataFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        chrLandingData: {
            ...state.chrLandingData,
            isLoading: false,
            isError: true,
            error
        }
    };
};
const updateChrServiceOrderInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        chrServiceOrder: {
            ...state.chrServiceOrder,
            isLoading: true
        }
    };
};
const updateChrServiceOrderSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        chrServiceOrder: {
            ...state.chrServiceOrder,
            isLoading: false,
            ...data
        }
    };
};
const updateChrServiceOrderFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        chrServiceOrder: {
            ...state.chrServiceOrder,
            isLoading: false,
            isError: true,
            error
        }
    };
};
const searchChrServiceOrderInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        chrServiceOrderList: {
            ...state.chrServiceOrderList,
            isLoading: true
        }
    };
};
const searchChrServiceOrderSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        chrServiceOrderList: {
            ...state.chrServiceOrderList,
            isLoading: false,
            data
        }
    };
};
const searchChrServiceOrderFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        chrServiceOrderList: {
            ...state.chrServiceOrderList,
            isLoading: false,
            isError: true,
            error
        }
    };
};
const fetchChrServiceOrderInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        chrServiceOrder: {
            ...state.chrServiceOrder,
            isLoading: true
        }
    };
};
const fetchChrServiceOrderSuccess = (state = INITIAL_STATE, { data }) => {
    const {carDetails = {}} = data || {};
    return {
        ...state,
        chrServiceOrder: {
            ...state.chrServiceOrder,
            isLoading: false,
            ...data
        },
        regoDetails: {
            ...state.regoDetails,
            chrRegoFormDetails: {
                userEmail: data.email,
                regNo: carDetails.regNo || "",
                vin: carDetails.regNo ? "" : carDetails.vin || "",
                state: carDetails.state || "",
                year: carDetails.year || ""
            }
        }
    };
};
const fetchChrServiceOrderFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        chrServiceOrder: {
            ...state.chrServiceOrder,
            isLoading: false,
            isError: true,
            error
        }
    };
};
const chrServiceOrderPaymentInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        chrServiceOrderPayment: {
            ...state.chrServiceOrderPayment,
            isLoading: true
        }
    };
};
const chrServiceOrderPaymentSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        chrServiceOrderPayment: {
            ...state.chrServiceOrderPayment,
            isLoading: false,
            data
        }
    };
};
const chrServiceOrderPaymentFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        chrServiceOrderPayment: {
            ...state.chrServiceOrderPayment,
            isLoading: false,
            isError: true,
            error
        }
    };
};

const updateChrFormState = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        currentFormState: data
    };
};
const chrPaymentSessionInit = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        sessionData: data
    };
};

const updateShowCarHistoryFlowInitModal = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        showCarHistoryFlowInitModal: data
    };
};

const updateChrFormDetails = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        regoDetails: {
            ...state.regoDetails,
            chrRegoFormDetails: {
                ...state.regoDetails.chrRegoFormDetails,
                ...data
            }
        }
    };
};

const fetchChrServiceOrderListInit = (state = INITIAL_STATE) => {
    return {
        ...state,
        chrServiceOrderList: {
            ...state.chrServiceOrderList,
            isLoading: true
        }
    };
};
const fetchChrServiceOrderListSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        chrServiceOrderList: {
            ...state.chrServiceOrderList,
            isLoading: false,
            ...data
        }
    };
};
const fetchChrServiceOrderListFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        chrServiceOrderList: {
            ...state.chrServiceOrderList,
            isLoading: false,
            isError: true,
            error
        }
    };
};

const resetChrFormDetails = (state = INITIAL_STATE) => {
    return {
        ...state,
        regoDetails: {
            ...state.regoDetails,
            chrRegoFormDetails: {
                ...INITIAL_STATE.regoDetails.chrRegoFormDetails
            }
        }
    };
};
const updatePaymentMode = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        chrServiceOrderPayment: {
            ...state.chrServiceOrderPayment,
            selectedPaymentMode: data
        }
    };
};
const updateAgree = (state = INITIAL_STATE) => {
    return {
        ...state,
        chrServiceOrderPayment: {
            ...state.chrServiceOrderPayment,
            agreeToTerms: !state.chrServiceOrderPayment.agreeToTerms

        }
    };
};

export const HANDLERS = {
    [Types.FETCH_CMS_CONTENT_INIT]: fetchCmsDataInit,
    [Types.FETCH_CMS_CONTENT_SUCCESS]: fetchCmsDataSuccess,
    [Types.FETCH_CMS_CONTENT_FAILURE]: fetchCmsDataFailure,
    [Types.CREATE_CHR_SERVICE_ORDER_INIT]: setCreateServiceOrderInit,
    [Types.CREATE_CHR_SERVICE_ORDER_SUCCESS]: setCreateServiceOrderSuccess,
    [Types.CREATE_CHR_SERVICE_ORDER_FAILURE]: setCreateServiceOrderFailure,
    [Types.FETCH_REGO_DETAILS_INIT]: fetchRegoDetailsInit,
    [Types.FETCH_REGO_DETAILS_SUCCESS]: fetchRegoDetailsSuccess,
    [Types.FETCH_REGO_DETAILS_FAILURE]: fetchRegoDetailsFailure,
    [Types.FETCH_CHR_LANDING_DATA_INIT]: fetchChrLandingDataInit,
    [Types.FETCH_CHR_LANDING_DATA_SUCCESS]: fetchChrLandingDataSuccess,
    [Types.FETCH_CHR_LANDING_DATA_FAILURE]: fetchChrLandingDataFailure,
    [Types.UPDATE_CHR_SERVICE_ORDER_INIT]: updateChrServiceOrderInit,
    [Types.UPDATE_CHR_SERVICE_ORDER_SUCCESS]: updateChrServiceOrderSuccess,
    [Types.UPDATE_CHR_SERVICE_ORDER_FAILURE]: updateChrServiceOrderFailure,
    [Types.SEARCH_CHR_SERVICE_ORDER_INIT]: searchChrServiceOrderInit,
    [Types.SEARCH_CHR_SERVICE_ORDER_SUCCESS]: searchChrServiceOrderSuccess,
    [Types.SEARCH_CHR_SERVICE_ORDER_FAILURE]: searchChrServiceOrderFailure,
    [Types.FETCH_CHR_SERVICE_ORDER_INIT]: fetchChrServiceOrderInit,
    [Types.FETCH_CHR_SERVICE_ORDER_SUCCESS]: fetchChrServiceOrderSuccess,
    [Types.FETCH_CHR_SERVICE_ORDER_FAILURE]: fetchChrServiceOrderFailure,
    [Types.CHR_SERVICE_ORDER_PAYMENT_INIT]: chrServiceOrderPaymentInit,
    [Types.CHR_SERVICE_ORDER_PAYMENT_SUCCESS]: chrServiceOrderPaymentSuccess,
    [Types.CHR_SERVICE_ORDER_PAYMENT_FAILURE]: chrServiceOrderPaymentFailure,
    [Types.UPDATE_FORM_STATE]: updateChrFormState,
    [Types.CHR_PAYMENT_SESSION_INIT]: chrPaymentSessionInit,
    [Types.UPDATE_SHOW_CAR_HISTORY_FLOW_INIT_MODAL]: updateShowCarHistoryFlowInitModal,
    [Types.UPDATE_CHR_FORM_DATA]: updateChrFormDetails,
    [Types.FETCH_CHR_SERVICE_ORDER_LIST_INIT]: fetchChrServiceOrderListInit,
    [Types.FETCH_CHR_SERVICE_ORDER_LIST_SUCCESS]: fetchChrServiceOrderListSuccess,
    [Types.FETCH_CHR_SERVICE_ORDER_LIST_FAILURE]: fetchChrServiceOrderListFailure,
    [Types.RESET_CHR_FORM_DETAILS]: resetChrFormDetails,
    [Types.UPDATE_PAYMENT_MODE]: updatePaymentMode,
    [Types.UPDATE_AGREE]: updateAgree
};
export default createReducer(INITIAL_STATE, HANDLERS);
